// @ts-nocheck
import React from 'react';
import { observer } from 'mobx-react';
import { Input } from '@gamesb42/ui-kit';
import ConfirmModalAppInfo from '../../../../components/ConfirmModalAppInfo';
import CheckBox from '../../../../components/CheckBox';
import TextArea from '../../../../components/TextArea';
import { appInfoInst } from '../AppInfo';

const AppInfoConfirmModal = observer(() => {
  return (
    <ConfirmModalAppInfo title="Please double-check your datа before you submit">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: '32px',
        }}
      >
        {/* 1 - Distribution Platforms */}
        <h3>
          <b>Where is your app or game distributed now?*</b>
        </h3>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
          }}
        >
          <CheckBox
            label="Apple App Store"
            onChange={() =>
              (appInfoInst.values.distribution.appleStore =
                !appInfoInst.values.distribution.appleStore)
            }
            checked={appInfoInst.values.distribution.appleStore}
          />
          {appInfoInst.values.distribution.appleStore && (
            <TextArea
              value={appInfoInst.values.distribution.appleStoreComment}
              label="Link to your game/app at Apple App Store*"
              onChange={(value) => {
                appInfoInst.values.distribution.appleStoreComment = value;
              }}
            />
          )}

          <CheckBox
            label="Google Play"
            onChange={() =>
              (appInfoInst.values.distribution.googleStore =
                !appInfoInst.values.distribution.googleStore)
            }
            checked={appInfoInst.values.distribution.googleStore}
          />
          {appInfoInst.values.distribution.googleStore && (
            <TextArea
              value={appInfoInst.values.distribution.googleStoreComment}
              label="Link to your game/app at Google Play*"
              onChange={(value) => {
                appInfoInst.values.distribution.googleStoreComment = value;
              }}
            />
          )}

          <CheckBox
            label="Steam"
            onChange={() =>
              (appInfoInst.values.distribution.steam =
                !appInfoInst.values.distribution.steam)
            }
            checked={appInfoInst.values.distribution.steam}
          />
          {appInfoInst.values.distribution.steam && (
            <TextArea
              value={appInfoInst.values.distribution.steamComment}
              label="Link to your game/app at Steam*"
              onChange={(value) => {
                appInfoInst.values.distribution.steamComment = value;
              }}
            />
          )}

          <CheckBox
            label="Other"
            onChange={() =>
              (appInfoInst.values.distribution.other =
                !appInfoInst.values.distribution.other)
            }
            checked={appInfoInst.values.distribution.other}
          />
          {appInfoInst.values.distribution.other && (
            <TextArea
              value={appInfoInst.values.distribution.otherComment}
              label="Enter your distribution platform"
              onChange={(value) => {
                appInfoInst.values.distribution.otherComment = value;
              }}
            />
          )}
        </div>

        {/* 2 - Monetization Model */}
        <h3>
          <b>Monetization model of your app/game?*</b>
        </h3>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
          }}
        >
          <CheckBox
            checked={appInfoInst.values.monetization === 'In-app purchase'}
            type="round"
            label="In-app purchase"
            onChange={() => {
              appInfoInst.values.monetization = 'In-app purchase';
            }}
          />
          <CheckBox
            checked={appInfoInst.values.monetization === 'Ads'}
            type="round"
            label="Ads"
            onChange={() => {
              appInfoInst.values.monetization = 'Ads';
            }}
          />
          <CheckBox
            checked={
              appInfoInst.values.monetization === 'In-app purchase & Ads'
            }
            type="round"
            label="In-app purchase & Ads"
            onChange={() => {
              appInfoInst.values.monetization = 'In-app purchase & Ads';
            }}
          />
          <CheckBox
            checked={appInfoInst.values.monetization === 'Premium'}
            type="round"
            label="Premium"
            onChange={() => {
              appInfoInst.values.monetization = 'Premium';
            }}
          />
          <CheckBox
            checked={appInfoInst.values.monetization === 'Subscription'}
            type="round"
            label="Subscription"
            onChange={() => {
              appInfoInst.values.monetization = 'Subscription';
            }}
          />
          <CheckBox
            checked={appInfoInst.values.monetization === "I don't know"}
            type="round"
            label="I don't know"
            onChange={() => {
              appInfoInst.values.monetization = "I don't know";
            }}
          />
          <CheckBox
            checked={appInfoInst.values.monetization === 'Other'}
            type="round"
            label="Other"
            onChange={() => {
              appInfoInst.values.monetization = 'Other';
            }}
          />
        </div>

        {/* 3 - UA Spend Sources */}
        <h3>
          <b>UA spends sources*</b>
        </h3>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
          }}
        >
          <CheckBox
            checked={appInfoInst.values.uaSpend.facebook}
            onChange={() =>
              (appInfoInst.values.uaSpend.facebook =
                !appInfoInst.values.uaSpend.facebook)
            }
            label="Facebook"
          />
          <CheckBox
            checked={appInfoInst.values.uaSpend.googleAds}
            onChange={() =>
              (appInfoInst.values.uaSpend.googleAds =
                !appInfoInst.values.uaSpend.googleAds)
            }
            label="Google Ads"
          />
          <CheckBox
            checked={appInfoInst.values.uaSpend.appleSearchAds}
            onChange={() =>
              (appInfoInst.values.uaSpend.appleSearchAds =
                !appInfoInst.values.uaSpend.appleSearchAds)
            }
            label="Apple Search Ads"
          />
          <CheckBox
            checked={appInfoInst.values.uaSpend.snapchat}
            onChange={() =>
              (appInfoInst.values.uaSpend.snapchat =
                !appInfoInst.values.uaSpend.snapchat)
            }
            label="Snapchat"
          />
          <CheckBox
            checked={appInfoInst.values.uaSpend.tikTok}
            onChange={() =>
              (appInfoInst.values.uaSpend.tikTok =
                !appInfoInst.values.uaSpend.tikTok)
            }
            label="Tik Tok"
          />
          <CheckBox
            checked={appInfoInst.values.uaSpend.unityAds}
            onChange={() =>
              (appInfoInst.values.uaSpend.unityAds =
                !appInfoInst.values.uaSpend.unityAds)
            }
            label="UnityAds"
          />
          <CheckBox
            checked={appInfoInst.values.uaSpend.dontKnow}
            onChange={() =>
              (appInfoInst.values.uaSpend.dontKnow =
                !appInfoInst.values.uaSpend.dontKnow)
            }
            label="I don't know"
          />
          <CheckBox
            checked={appInfoInst.values.uaSpend.other}
            onChange={() =>
              (appInfoInst.values.uaSpend.other =
                !appInfoInst.values.uaSpend.other)
            }
            label="Other"
          />
        </div>

        {/* 4 - MMP Tracking Service */}
        <h3>
          <b>Your current MMP (tracking service)*</b>
        </h3>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
          }}
        >
          <CheckBox
            label="Adjust"
            onChange={() =>
              (appInfoInst.values.mmp.adjust = !appInfoInst.values.mmp.adjust)
            }
            checked={appInfoInst.values.mmp.adjust}
          />
          <CheckBox
            onChange={() =>
              (appInfoInst.values.mmp.appsflyer =
                !appInfoInst.values.mmp.appsflyer)
            }
            checked={appInfoInst.values.mmp.appsflyer}
            label="Appsflyer"
          />
          <CheckBox
            onChange={() =>
              (appInfoInst.values.mmp.tenjin = !appInfoInst.values.mmp.tenjin)
            }
            checked={appInfoInst.values.mmp.tenjin}
            label="Tenjin"
          />
          <CheckBox
            onChange={() =>
              (appInfoInst.values.mmp.kochava = !appInfoInst.values.mmp.kochava)
            }
            checked={appInfoInst.values.mmp.kochava}
            label="Kochava"
          />
          <CheckBox
            onChange={() =>
              (appInfoInst.values.mmp.branch = !appInfoInst.values.mmp.branch)
            }
            checked={appInfoInst.values.mmp.branch}
            label="Branch"
          />
          <CheckBox
            onChange={() =>
              (appInfoInst.values.mmp.firebase =
                !appInfoInst.values.mmp.firebase)
            }
            checked={appInfoInst.values.mmp.firebase}
            label="Firebase"
          />
          <CheckBox
            onChange={() =>
              (appInfoInst.values.mmp.dontKnow =
                !appInfoInst.values.mmp.dontKnow)
            }
            checked={appInfoInst.values.mmp.dontKnow}
            label="I don't know"
          />
          <CheckBox
            onChange={() =>
              (appInfoInst.values.mmp.other = !appInfoInst.values.mmp.other)
            }
            checked={appInfoInst.values.mmp.other}
            label="Other"
          />
        </div>

        {/* 5 - Additional Info */}
        <h3>
          <b>Additional info about the project</b>
        </h3>
        <Input.TextArea
          label="Comment"
          disabled={false}
          showCount={true}
          maxLength={400}
          value={appInfoInst.values.additionalInfo}
          onChange={(e) => {
            appInfoInst.values.additionalInfo = e.target.value;
          }}
        />
      </div>
    </ConfirmModalAppInfo>
  );
});

export default AppInfoConfirmModal;
